import { useEffect, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  Box,
  Chip,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { DeleteEmployeeExpenseAction } from "../../../../../store/Finance/Expense/Action";
import { ConvertDate } from "../../../Base/helper/baseFunctions";
import Popup from "../../../Base/views/Popup";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import EmployeePreview from "./EmployeePreview";
import { GetAdminExitEmployeeAction } from "../../../../../store/Employee/EcmsAdmin/Action";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";

const AdminEcmsEmployee = () => {
  const dispatch = useDispatch();
  const { empAdminLoading, adminExitEmployeeData } = useSelector(
    (state) => state?.EmployeeReducer.ECMSAdminActionReducer
  );
  const filteredExitEmployeeData = adminExitEmployeeData?.filter((el) => el?.exit_status === "In Progress" || el?.exit_status === "Completed")
  const [filters, setFilters] = useState({
                ats_work_location_id: []
            });
  const [openPopup, setOpenPopup] = useState(false);
  const [employeeRecord, setEmployeeRecord] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentData, setCurrentData] = useState(null);
 

  const closeMode = (callFetch) => {
    setEmployeeRecord(null);
    setOpenPopup(false);
    const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
    if(callFetch) {
      dispatch(GetAdminExitEmployeeAction({view_usertype: "Admin",
                ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
      }))
    }
  };

  const handleDelete = () => {
    setOpenDialog(false);
    dispatch(DeleteEmployeeExpenseAction({ employee_expenses_pk: currentData?.employee_expenses_pk }))
    setCurrentData(null);
  };

  useEffect(() => {
    const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
    dispatch(GetAdminExitEmployeeAction({view_usertype: "Admin",
              ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
    }))  // 'Admin' / 'Manager
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);
  const handleEmployeeClicked =  (event, rowData) => {
    event.stopPropagation();
    setEmployeeRecord(rowData);
    setOpenPopup(true);    
  };
 const { workLocationAccess_options } = useSelector(state => state?.AncillaryReducer?.WorkLocationReducer);
  const [worklocationData, setWorklocationData] = useState({
                load: true,
                values: [],
            });
  const handleWorkLoacation = () => {
      if(workLocationAccess_options) {
          setWorklocationData({ load: false, values: workLocationAccess_options || [] })
      } else {
          setWorklocationData({ load: false, values: [] })
      }
  }
  useEffect(() => {
      handleWorkLoacation();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[workLocationAccess_options])
  const handleFilterChange = (event, value) => {
    if (["ats_work_location_id"].includes(event)) {
      if (value) {
          setFilters({ ...filters, [event]: value });
      } else {
          setFilters({ ...filters, [event]: "" });
      }
    }
  }
  return (
      <Box sx={{ height: "calc(100vh - 125px)", overflowY: 'auto'}}>
        <Box>
          <MaterialTable
            isLoading={empAdminLoading}
            onRowClick={(event, rowData) => {
              handleEmployeeClicked(event, rowData);
            }}
            columns={[
              {
                title: "Name",
                field: "name",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "12px 0px 12px 13px"
                },
              },
              {
                title: "Reporting Manager",
                field: "rm_name",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "12px 0px 12px 13px"
                },
              },
              {
                title: "Location",
                field: "work_location_name",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "12px 0px 12px 13px"
                },
                render: (rowData) => rowData?.work_location_name || "N/A"
              },
              {
                field: "doj",
                title: "DOJ",
                render: (rowData) => ConvertDate(rowData?.doj),
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "12px 0px 12px 13px"
                },
              },
              {
                field: "resignation_date",
                title: "Resignation Date",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "12px 0px 12px 13px"
                },
                render: (rowData) => ConvertDate(rowData?.resignation_date)
              },
              {
                field: "lwd",
                title: "Last Working Date",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "12px 0px 12px 13px"
                },
                render: (rowData) => ConvertDate(rowData?.lwd)
              },
              {
                field: "exit_status",
                title: "Exit Status",
                headerStyle: {
                  textAlign: "center",
                },
                cellStyle: {
                  textAlign: "center",
                  padding: "12px 0px 12px 13px"
                },
                render: (rowData) => {
                  const { bg, text } = getStatusColor(rowData.exit_status);
                  return (
                    <Chip
                      label={rowData?.exit_status}
                      style={{
                        backgroundColor: bg,
                        color: text,
                        fontWeight: 500,
                      }}
                      size="small"
                    />
                  );
                },
              },
            ]}
            data={filteredExitEmployeeData || []}
            options={{
              maxBodyHeight: "calc(100vh - 245px)",
              minBodyHeight: "calc(100vh - 245px)",
              rowStyle: {
                fontSize: "13px",
              },
              headerStyle: {
                padding: "7px 10px 7px 10px",
                fontWeight: "bold",
              },
              sorting: false,
              search: true,
              searchFieldAlignment: "right",
              searchAutoFocus: false,
              filtering: false,
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              selection: false,
              actionsColumnIndex: -1,
              grouping: false,
              columnsButton: false,
              showTitle: true,
              exportAllData: false,
              exportButton: false,
            }}
            title={""}
            components={{
              Toolbar: (props) => (
                  <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                      <Box
                          sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#f3edfd",
                          padding: "0px 0px 0px 20px",
                          flexGrow: 1,
                          minHeight: "48px !important",
                          }}
                      >
                      <Box>
                          <Typography variant='h6'>
                              Exit Employee
                          </Typography>
                      </Box>
                      <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                          <SelectableMultiSelect
                              multiple
                              label="Location"
                              placeholder="Select Location"
                              value={filters?.ats_work_location_id}
                              loading={handleWorkLoacation}
                              fieldLabel="work_location_name"
                              name="ats_work_location_id"
                              size="small"
                              onChangeEvent={handleFilterChange}
                              data={worklocationData}
                              menuHeight={150} // optional
                          />
                      </Box> 
                      </Box>
                      <Box
                          sx={{
                              "& .MuiToolbar-root": {
                              padding: "14px 16px !important",
                              margin: "auto !important",
                              minHeight: "48px !important",
                              },
                              "& .MuiFormControl-root": {
                              margin: "0 !important",
                              },
                              "& .MuiInputBase-root": {
                              marginLeft: "-40px !important",
                              }
                          }}
                          >
                              <MTableToolbar {...props} />
                          </Box>
                      </Box>
              ),
            }}
          />
        </Box>
        <Popup
          title={`Exit Employee Overview`}
          openPopup={openPopup}
          setOpenPopup={closeMode}
          fullWidth={true}
          maxWidth="sm"
        >
          <EmployeePreview
            setOpenPopup={setOpenPopup}
            employeeRecord={employeeRecord}
            closeMode={closeMode}
          />
        </Popup>
        <ConfirmationDialog
          title="Do you wish to proceed?"
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          popupTitle="Country Management"
          OkButtonText="Delete"
          onSubmit={handleDelete}
        />
      </Box>
  );
};

const getStatusColor = (status) => {
  switch (status) {
    case "In Progress":
      return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
    case "Completed":
      return { bg: "#E8F5E9", text: "#66BB6A" }; // green
    case "Rejected":
      return { bg: "#FFEBEE", text: "#EF5350" }; // red
    case "Submitted":
      return { bg: "#E3F2FD", text: "#42A5F5" };
    default:
      return { bg: "#E5E7EB", text: "#374151" }; // gray
  }
};

export default AdminEcmsEmployee;
